import type { FC, SVGProps } from 'react'

export const Youtube: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.7049 4.6301C14.6252 4.33412 14.4692 4.06425 14.2525 3.84752C14.0357 3.63078 13.7659 3.47477 13.4699 3.3951C12.3799 3.1001 7.99989 3.1001 7.99989 3.1001C7.99989 3.1001 3.61989 3.1001 2.52989 3.3951C2.23391 3.47477 1.96404 3.63078 1.74731 3.84752C1.53057 4.06425 1.37456 4.33412 1.29489 4.6301C1.09136 5.74173 0.992594 6.87001 0.999888 8.0001C0.992594 9.13019 1.09136 10.2585 1.29489 11.3701C1.37456 11.6661 1.53057 11.9359 1.74731 12.1527C1.96404 12.3694 2.23391 12.5254 2.52989 12.6051C3.61989 12.9001 7.99989 12.9001 7.99989 12.9001C7.99989 12.9001 12.3799 12.9001 13.4699 12.6051C13.7659 12.5254 14.0357 12.3694 14.2525 12.1527C14.4692 11.9359 14.6252 11.6661 14.7049 11.3701C14.9084 10.2585 15.0072 9.13019 14.9999 8.0001C15.0072 6.87001 14.9084 5.74173 14.7049 4.6301ZM6.59989 10.1001V5.9001L10.2349 8.0001L6.59989 10.1001Z"
      fill="currentColor"
    />
  </svg>
)
